/**
 * Line groups (v7.180.0). A packaging route's line cells name a LINE GROUP;
 * a line's group is the workstation-downtime table's `resourceGroupCode`
 * (blank = the line is its own group). The Portal's copy of the engine's
 * `line_groups.rs` membership rule, for screens that must offer real lines —
 * a carry-over sits on one specific line, never on a group.
 */

type DowntimeRow = {
  resource?: unknown
  resourceType?: unknown
  resourceGroupCode?: unknown
}

const text = (v: unknown): string =>
  v === null || v === undefined ? '' : String(v).trim()

/** group code -> member lines, for groups that are not just one line named
 *  after itself. */
export function lineGroupMembers(
  rows: DowntimeRow[] | undefined
): Map<string, string[]> {
  const groupOf = new Map<string, string>()
  for (const r of rows ?? []) {
    if (text(r.resourceType).toLowerCase() !== 'line') continue
    const line = text(r.resource)
    if (!line) continue
    const group = text(r.resourceGroupCode) || line
    const existing = groupOf.get(line)
    if (existing === undefined || existing === line) groupOf.set(line, group)
  }
  const members = new Map<string, string[]>()
  groupOf.forEach((group, line) => {
    members.set(group, [...(members.get(group) ?? []), line])
  })
  members.forEach((lines, group) => {
    if (lines.length === 1 && lines[0] === group) members.delete(group)
  })
  return members
}

/** The real lines a route line cell can run on. */
export const linesOf = (
  cell: string,
  members: Map<string, string[]>
): string[] => members.get(cell) ?? [cell]
